import {
    Drawer, useMediaQuery, useTheme
} from "@mui/material";
import { APPBAR_HEIGHT } from "../../Helpers/Constants"; // Import the constant for app bar height
import { getRightOrLeft } from "../../Helpers/Utils";
import { drawerWidth, collapsedDrawerWidth } from "../Dashboard";
import DrawerContent from "./DrawerContent";

const DashboardDrawer = ({ data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { handleDrawerToggle, mobileOpen, drawerCollapsed, onToggleDrawerCollapse } = data;
    const currentWidth = isMobile ? drawerWidth : (drawerCollapsed ? collapsedDrawerWidth : drawerWidth);

    return (
        <Drawer
            container={window.document.body}
            anchor={getRightOrLeft()}
            variant={isMobile ? "temporary" : "permanent"}
            open={isMobile ? mobileOpen : true}
            onClose={handleDrawerToggle}
            ModalProps={{
                keepMounted: true, // Better performance on mobile
            }}
            sx={{
                width: { md: currentWidth },
                flexShrink: { md: 0 },
                zIndex: (theme) => theme.zIndex.drawer,
                "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: currentWidth,
                    // Position drawer below app bar on mobile
                    marginTop: isMobile ? APPBAR_HEIGHT : 0,
                    height: isMobile ? `calc(100% - ${APPBAR_HEIGHT})` : '100%',
                    background: (theme) => theme.palette.mode === 'dark'
                        ? 'linear-gradient(180deg, rgba(18, 18, 18, 0.95) 0%, rgba(28, 28, 28, 0.95) 100%)'
                        : 'linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
                    // backdropFilter: 'blur(20px) saturate(180%)',
                    // WebkitBackdropFilter: 'blur(20px) saturate(180%)', // Safari support
                    borderRight: (theme) => theme.palette.mode === 'dark'
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.08)',
                    boxShadow: (theme) => theme.palette.mode === 'dark'
                        ? '8px 0 40px rgba(0, 0, 0, 0.4), inset -1px 0 0 rgba(255, 255, 255, 0.05)'
                        : '8px 0 40px rgba(0, 0, 0, 0.1), inset -1px 0 0 rgba(255, 255, 255, 0.5)',
                    transition: 'all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    // Modern scrollbar styling
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: (theme) => theme.palette.mode === 'dark'
                            ? 'rgba(255, 255, 255, 0.2)'
                            : 'rgba(0, 0, 0, 0.2)',
                        borderRadius: '3px',
                        '&:hover': {
                            background: (theme) => theme.palette.mode === 'dark'
                                ? 'rgba(255, 255, 255, 0.3)'
                                : 'rgba(0, 0, 0, 0.3)',
                        }
                    },
                    // Enhanced mobile experience
                    ...(isMobile && {
                        '& .MuiBackdrop-root': {
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            backdropFilter: 'blur(8px)',
                        }
                    })
                },
            }}
        >
            <DrawerContent data={data} isMobile={isMobile} collapsed={!isMobile && drawerCollapsed} onToggleCollapse={onToggleDrawerCollapse} />
        </Drawer>
    );
};

export default DashboardDrawer;
